import { Divider } from '@mui/material';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IAutomatedEmailCampaignListPayload } from 'wisestep-api';
import { WsListingLoader, WsPaginationBar, WsTypography, WsTypoVariants } from 'wisestep-base';

import useGetJobEmailLogs from '../../hooks/useGetJobEmailLogs';
import { getJobEmailCampaigntPayload } from '../../util/JobCampaignEmailHelper';
import { EmailLayout } from '../layout/emailLayout';
import { NoEmailCampaignResponse } from '../noEmailResponse';

export const EmailCampaignResponse = () => {
  const [params] = useSearchParams();
  const jobId = params.get('jobId') ?? '';
  const campaignCode = params.get('campaignCode') ?? '';

  const [searchParams, setSearchParams] = useState<IAutomatedEmailCampaignListPayload>(
    getJobEmailCampaigntPayload(jobId, campaignCode, 'IN_BOUND')
  );
  const handlePageChange = (newPage: number) => setSearchParams({ ...searchParams, page: newPage });

  const handlePageSizeChange = (newPageSize: number) =>
    setSearchParams({ ...searchParams, size: newPageSize, page: 0 });
  const { emailList, loading } = useGetJobEmailLogs(searchParams);

  return (
    <>
      {loading ? (
        <WsListingLoader minHeight={400} />
      ) : emailList?.content?.length ? (
        <>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
            Emails with Response
          </WsTypography>
          <WsPaginationBar
            totalRecords={emailList.totalElements}
            page={searchParams.page}
            pageSize={searchParams.size}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
          <Divider />
          <EmailLayout emailList={emailList} jobId={jobId} />
        </>
      ) : (
        <>
          <WsTypography bold>Emails With Responses</WsTypography>
          <NoEmailCampaignResponse />
        </>
      )}
    </>
  );
};
